export enum AccountAttribute {
  Local = 'LOCAL',
  SysAdmin = 'SYS_ADMIN',
  Otpw = 'OTPW',
  PasswordChangeRequired = 'PASSWORD_CHANGE_REQUIRED',
}
